import React, {Component} from 'react';
import './XMLFileFormatDetails.css';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, Button} from 'reactstrap';
import {sharedLabelsPath} from "../../../../reducers/common/localization";

const BULK_FILE_EXAMPLE = [
    "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n",
    "<accreditations xmlns=\"http://www.wickedware.eu/xmlschemas\">\n",
    "\t<accreditation>\n",
    "\t\t<email>test@test.com</email>\n",
    "\t\t<firstName>Test</firstName>\n",
    "\t\t<lastName>Testovich</lastName>\n",
    "\t\t<countryCode>BY</countryCode>\n",
    "\t\t<nationalId>MP1112233</nationalId>\n",
    "\t\t<issuedAt>2018-01-30</issuedAt>\n",
    "\t\t<level>BACHELOR</level>\n",
    "\t\t<titles>\n",
    "\t\t\t<title language=\"original\">Test Accreditation</title>\n",
    "\t\t\t<title language=\"en\">Test Accreditation</title>\n",
    "\t\t\t<title language=\"fr\">Test d'accréditation</title>\n",
    "\t\t</titles>\n",
    "\t</accreditation>\n",
    "\t<accreditation>\n",
    "\t\t<email>test@test.by</email>\n",
    "\t\t<firstName>Test</firstName>\n",
    "\t\t<lastName>Testovich</lastName>\n",
    "\t\t<countryCode>BY</countryCode>\n",
    "\t\t<nationalId>MP1112233</nationalId>\n",
    "\t\t<issuedAt>2018-01-30</issuedAt>\n",
    "\t\t<level>BACHELOR</level>\n",
    "\t\t<titles>\n",
    "\t\t\t<title language=\"original\">Test Accreditation</title>\n",
    "\t\t\t<title language=\"en\">Test Accreditation</title>\n",
    "\t\t</titles>\n",
    "\t</accreditation>\n",
    "</accreditations>"
];

const VALUES_DETAILS = [
    {
        name: "accreditations",
        isRequired: "yes_label",
        mean: "accreditations_meaning_label",
        format: "<accreditation>\n\t...\n</accreditation>\n...\n<accreditation>\n\t...\n</accreditation>",
    },
    {
        name: "accreditation",
        isRequired: "no_label",
        mean: "accreditation_meaning_label",
        format: "<email>...</email>\n" +
        "<firstName>...</firstName>\n" +
        "<lastName>...</lastName>\n" +
        "<countryCode>...</countryCode>\n" +
        "<nationalId>...</nationalId>\n" +
        "<issuedAt>...</issuedAt>\n" +
        "<level>...</level>\n" +
        "<titles>...</titles>",
    },
    {
        name: "email",
        isRequired: "no_label",
        mean: "email_mean_label",
        format: "email_format",
    },
    {
        name: "firstName",
        isRequired: "yes_label",
        mean: "first_name_mean_label",
        format: "string_format",
    },
    {
        name: "lastName",
        isRequired: "yes_label",
        mean: "last_name_mean_label",
        format: "string_format",
    },
    {
        name: "countryCode",
        isRequired: "yes_label",
        mean: "country_code_mean_label",
        format: "country_code_format",
    },
    {
        name: "nationalId",
        isRequired: "yes_label",
        mean: "national_id_mean_label",
        format: "string_format",
    },
    {
        name: "issuedAt",
        isRequired: "yes_label",
        mean: "date_issued_mean_label",
        format: "date_format",
    },
    {
        name: "level",
        isRequired: "yes_label",
        mean: "level_mean_label",
        format: "level_format",
    },
    {
        name: "titles",
        isRequired: "yes_label",
        mean: "titles_meaning_label",
        format: "<title language=\"...\">...</title>\n\t...\n<title language=\"...\">...</title>",
    },
    {
        name: "title",
        isRequired: "yes_label",
        attributes: ["language"],
        mean: "title_meaning_label",
        format: "string_format",
    }
];

class XMLFileFormatDetails extends Component {
    render() {
        return (
            <div className='bulk-xml-file-format-details-container'>
                <div
                    className='bulk-xml-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.use_xml_message')}</div>

                <h5 className="text-center">{_.get(this.props.translation, 'bulk_file_format_details.xml_file_example_label')}</h5>
                <div className="bulk-xml-file-example">
                    {this.getFileExampleText()}
                </div>
                <div className="bulk-xml-example-download-container">
                    <Button
                        onClick={this.downloadXMLFile}>{_.get(this.props.translation, 'bulk_file_format_details.download_example_button')}</Button>
                </div>

                <div
                    className='bulk-xml-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.file_header_message')}</div>
                <div className='bulk-xml-file-format-info bulk-header-list'>
                    {'<?xml version="1.0" encoding="UTF-8"?>'}
                </div>
                <div
                    className='bulk-xml-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.then_provide_message')}</div>
                <ul className='bulk-xml-file-format-requirements-list'>
                    <li className='bulk-xml-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.applicant_data_message')}</li>
                    <li className='bulk-xml-file-format-info'>{_.get(this.props.translation, 'bulk_file_format_details.accreditation_data_message')}</li>
                </ul>

                <h5 className="text-center bulk-xml-file-format-values-detail-header">{_.get(this.props.translation, 'bulk_file_format_details.values_details_label')}</h5>
                <div
                    className='bulk-xml-file-format-info'>{"*" + _.get(this.props.translation, 'bulk_file_format_details.email_details')}</div>
                <div
                    className='bulk-xml-file-format-info'>{"**" + _.get(this.props.translation, 'bulk_file_format_details.date_issued_details')}</div>
                <div
                    className='bulk-xml-file-format-info'>{"***" + _.get(this.props.translation, 'bulk_file_format_details.title_details')}</div>
                {this.renderValueDetailsTable()}
            </div>
        );
    }

    renderValueDetailsTable = () => {
        return (
            <Table className="bulk-xml-values-details-table" bordered>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.tag_name_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.required_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.attributes_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.mean_label')}</th>
                    <th>{_.get(this.props.translation, 'bulk_file_format_details.format_label')}</th>
                </tr>
                </thead>
                <tbody>
                {this.renderValuesDetailsData()}
                </tbody>
            </Table>
        )
    };

    renderValuesDetailsData = () => {
        return _.map(VALUES_DETAILS, (elem, id) => (
            <tr key={id}>
                <td className="tags-codes-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.tag_name_label') + ":"}>
                    {elem.name}
                </td>
                <td className="required-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.required_label') + ":"}>
                    {_.get(this.props.translation, sharedLabelsPath[elem.isRequired]) + (elem.name === "email" ? " (*)" : "") + (elem.name === "title" ? " (***)" : "")}
                </td>
                <td className="attributes-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.attributes_label') + ":"}>
                    {elem.attributes ? elem.attributes.join(',') : '-'}
                </td>
                <td className="mean-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.mean_label') + ":"}>
                    {_.get(this.props.translation, "bulk_file_format_details." + elem.mean)}
                </td>
                <td className="format-td"
                    data-th={_.get(this.props.translation, 'bulk_file_format_details.format_label') + ":"}>
                    {_.get(this.props.translation, "bulk_file_format_details." + elem.format) || <pre>{elem.format}</pre>}
                </td>
            </tr>
        ));
    };

    getFileExampleText = () => {
        let result = [];
        BULK_FILE_EXAMPLE.forEach((row) => {
            result.push(row);
        });
        return (
            <pre>{result}</pre>
        );
    };

    downloadXMLFile = () => {
        let element = document.createElement("a");
        let file = new Blob(BULK_FILE_EXAMPLE, {type: 'application/xml'});
        element.href = URL.createObjectURL(file);
        element.download = "bulk_xml_file_example.xml";
        element.click();
    }
}

XMLFileFormatDetails.propTypes = {
    translation: PropTypes.object.isRequired
};

export default XMLFileFormatDetails;



// WEBPACK FOOTER //
// ./src/components/commonComponents/bulkFileFormatDetails/XMLFileFormatDetails/XMLFileFormatDetails.js